import React from 'react';
import Input from './style';
const InputText = ({type = 'text', value, onChange, ...props})=>{
	return (
		<Input type={type} value={value || ""} onChange={onChange || (()=>null) } {...props}/>
	)
}

export default InputText;